/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetActivityLogsResponse } from '../model';
/**
 * ActivityLogsApi - axios parameter creator
 * @export
 */
export const ActivityLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogByKeyword: async (keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/activity-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityLogsApi - functional programming interface
 * @export
 */
export const ActivityLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivityLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityLogByKeyword(keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActivityLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityLogByKeyword(keyword, limit, page, orderBy, orderDesc, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ActivityLogsApi - factory interface
 * @export
 */
export const ActivityLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivityLogsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogByKeyword(keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, startDate?: string, endDate?: string, options?: any): AxiosPromise<GetActivityLogsResponse> {
            return localVarFp.getActivityLogByKeyword(keyword, limit, page, orderBy, orderDesc, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getActivityLogByKeyword operation in ActivityLogsApi.
 * @export
 * @interface ActivityLogsApiGetActivityLogByKeywordRequest
 */
export interface ActivityLogsApiGetActivityLogByKeywordRequest {
    /**
     * 
     * @type {string}
     * @memberof ActivityLogsApiGetActivityLogByKeyword
     */
    readonly keyword?: string

    /**
     * 
     * @type {number}
     * @memberof ActivityLogsApiGetActivityLogByKeyword
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof ActivityLogsApiGetActivityLogByKeyword
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof ActivityLogsApiGetActivityLogByKeyword
     */
    readonly orderBy?: string

    /**
     * 
     * @type {string}
     * @memberof ActivityLogsApiGetActivityLogByKeyword
     */
    readonly orderDesc?: string

    /**
     * 
     * @type {string}
     * @memberof ActivityLogsApiGetActivityLogByKeyword
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof ActivityLogsApiGetActivityLogByKeyword
     */
    readonly endDate?: string
}

/**
 * ActivityLogsApi - object-oriented interface
 * @export
 * @class ActivityLogsApi
 * @extends {BaseAPI}
 */
export class ActivityLogsApi extends BaseAPI {
    /**
     * 
     * @param {ActivityLogsApiGetActivityLogByKeywordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogsApi
     */
    public getActivityLogByKeyword(requestParameters: ActivityLogsApiGetActivityLogByKeywordRequest = {}, options?: AxiosRequestConfig) {
        return ActivityLogsApiFp(this.configuration).getActivityLogByKeyword(requestParameters.keyword, requestParameters.limit, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
}
